module.exports = __webpack_public_path__ + "static/media/birthdate-infographic.b37249fc.svg";